/** Minimum seconds per full 360° cycle (stored value; 0 = fastest in UI). */
export const PATROL_ROTATION_DURATION_MIN_SEC = 0;

/** Maximum seconds per full 360° auto-rotation cycle (Patrol settings + player). */
export const PATROL_ROTATION_DURATION_MAX_SEC = 150;

/** Default when opening Patrol or when the saved value is invalid. */
export const DEFAULT_PATROL_ROTATION_DURATION_SECONDS = 20;

/**
 * Clamp to integer seconds in [min, max]. Invalid input falls back to default.
 * @param {unknown} value
 * @returns {number}
 */
export function normalizePatrolRotationDurationSeconds(value) {
  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue)) {
    return DEFAULT_PATROL_ROTATION_DURATION_SECONDS;
  }
  const rounded = Math.round(parsedValue);
  return Math.min(
    PATROL_ROTATION_DURATION_MAX_SEC,
    Math.max(PATROL_ROTATION_DURATION_MIN_SEC, rounded),
  );
}

/**
 * Milliseconds for one full 360° auto-rotation. Values ≤ 0 use 1s so the loop never divides by zero.
 * @param {unknown} rotationDurationSeconds
 * @returns {number} milliseconds
 */
export function patrolRotationDurationMs(rotationDurationSeconds) {
  const sec = normalizePatrolRotationDurationSeconds(rotationDurationSeconds);
  const effectiveSeconds = sec <= 0 ? 1 : sec;
  return effectiveSeconds * 1000;
}
